<template>
  <v-container fluid fill-height>
    <v-row class="mb-5">
      <v-col xs="12" md="4" lg="3" xl="3"><img :src="`${publicPath}img/ubisell-logo.png`" width="200"></v-col>
      <v-col align-self="center"><h1>Leggi il QR Code relativo al modulo da attivare</h1></v-col>
    </v-row>
    <v-card class="mr-5">
      <v-card-title>
        Mobile Platform
      </v-card-title>
      <v-card-subtitle v-if="isPlatform">Dashboard, picking, ordini, per clienti Ubisell</v-card-subtitle>
      <v-card-subtitle v-else>Licenza non abilitata</v-card-subtitle>
      <v-card-text>
        <qrcode-vue v-if="isPlatform" :value="linkMobilePlatform" :size="size" level="M"/>
        <img v-else :src="`${publicPath}img/ubisell-logo.png`" width="300">
        <div>{{linkMobilePlatform}}</div>
      </v-card-text>
    </v-card>
    <v-card>
    <v-card-title>
        Mobile Data Collector
      </v-card-title>
      <v-card-subtitle v-if="isCollector">Dashboard e statistiche per clienti non Ubisell (modulo collector)</v-card-subtitle>
      <v-card-subtitle v-else>Licenza non abilitata</v-card-subtitle>
      <v-card-text>
        <qrcode-vue v-if="isCollector" :value="linkMobileCollector" :size="size" level="M" />
        <img v-else :src="`${publicPath}img/ubisell-logo.png`" width="300">
        <div>{{linkMobileCollector}}</div>
      </v-card-text>
    </v-card>    
  </v-container>
</template>

<script>
// import VueQrcode from 'vue-qrcode'
import QrcodeVue from '@/plugins/qrcode/qrcode.vue.js'
import { verificaLicenza } from '@/mixins/verificaLicenza.js'

export default {
  components: {
    QrcodeVue
  },
  mixins: [verificaLicenza],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      size: 300,
      linkMobilePlatform: 'https://pl.mobile.ubisell.ubi-co.com',
      linkMobileCollector: 'https://cl.mobile.ubisell.ubi-co.com',
      isPlatform: false,
      isCollector: false
    }
  },
  async mounted () {
    await this.gestioneToken()
    let resp = await this.getTokenDispositivo()
    let buff = Buffer.from(resp, 'base64')
    let text = buff.toString('ascii')
    const tk = JSON.parse(text)

    if (tk.module) {
      this.linkMobilePlatform = `https://pl.mobile.ubisell.ubi-co.com/register/${tk.key}/${tk.module}/${tk.base}${tk.service ? '?service=true' : ''}`
      this.isPlatform = true
    }
    if (tk.collector) {
      this.linkMobileCollector = `https://cl.mobile.ubisell.ubi-co.com/register/${tk.key}/${tk.collector}/${tk.base}${tk.service ? '?service=true' : ''}`
      this.isCollector = true
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
  .licenza {
    display: block;
    width: 100vw;
    height: 100vh;
    text-align: center;
    box-sizing: border-box;
    padding-top: 20vh;
  }
</style>
